import { render, staticRenderFns } from "./CustomerImport.vue?vue&type=template&id=13ca8c52&"
import script from "./CustomerImport.vue?vue&type=script&lang=js&"
export * from "./CustomerImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports